import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

class GridActionContent extends Component {
    render() {
        const { t, styleWidth, styleHight, gridObjData, editButtonShow, deleteButtonShow, roleManagePermissionButtonShow, cancellationBtnShow, checkinCheckoutBtnShow, checkinCheckoutLabel, roomEditBtnShow, createInvoiceBtnShow, makePaymentShow, quotationDetailsShow, quotationBookingConversionBtnShow, resendBookingDetailsShow, staffHistoryButtonShow, resendQuationButtonShow, viewButtonShow, subscribeNow, renewsubscribe, subscribeEdit, subscribeExtendNow, makeDefaultButtonShow, makePaymentDetailsShow, paymentDetailsShow, approveShow, personDetailsShow, personDetailsFn, paymentAcceptShow, paymentRejectShow, auditHistoryShow, beneficiarySettlementShow, addPaymentShow, beneficiarySettlementLabel, give_me_authorization_show, viewLabel, add_to_active_list_show, remove_property_show, completeBookingShow, assignRoomNumberShow } = this.props;
        return (
            <div className="actionableInnerBoxContainer" style={{ position: 'absolute', left: `${styleWidth}`, top: `${styleHight}` }} ref={this.props.codeOutsideClickRef}>
                <div className="actionableBtnCenter">
                    {addPaymentShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.addPaymentFn.bind(this, gridObjData)}><span><i className="fa fa-file-text"></i></span>Add Payment</button>
                    </div> : null}
                    {quotationDetailsShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.quotationDetailsFn.bind(this, gridObjData)}><span><i className="fa fa-info-circle"></i></span>Quotation Details</button>
                    </div> : null}
                    {editButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={() => { this.props.modefier(gridObjData, "") }}><span><i className="fa fa-pencil" ></i></span> {t('edit')}</button>
                    </div> : null}
                    {roleManagePermissionButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={() => { this.props.roleManagePermissionFn(gridObjData, "") }}><span><i className="fa fa-pencil" ></i></span> {t('managePermission')}</button>
                    </div> : null}
                    {quotationBookingConversionBtnShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.quotationBookingConversionFn.bind(this, gridObjData)}><span><i className="fa fa-exchange"></i></span>Quotation to Booking Conversion</button>
                    </div> : null}
                    {makeDefaultButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={() => { this.props.makeDefault(gridObjData, "") }}><span><i className="fa fa-file-text" ></i></span>Make Default</button>
                    </div> : null}
                    {deleteButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.delete.bind(this, gridObjData)}><span><i className="fa fa-trash"></i></span> {t('delete')}</button>
                    </div> : null}

                    {checkinCheckoutBtnShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.checkinCheckout.bind(this, gridObjData)}><span><i className="fa-solid fa-square-check"></i></span>{checkinCheckoutLabel}</button>
                    </div> : null}

                    {cancellationBtnShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.cancellation.bind(this, gridObjData)}><span><i className="fa-solid fa-book"></i></span>Cancel Booking</button>
                    </div> : null}

                    {makePaymentShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.makePaymentFn.bind(this, gridObjData)}><span><i className="fa fa-file-text"></i></span>Payments</button>
                    </div> : null}
                    {makePaymentDetailsShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.resendBookingDetailsFn.bind(this, gridObjData, "paymentDetailsResend")}><span><i className="fa fa-file-text"></i></span>Resend Payment Details</button>
                    </div> : null}

                    {viewButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.view.bind(this, gridObjData)}><span><i className="fa fa-eye"></i></span>{viewLabel}</button>
                    </div> : null}

                    {resendBookingDetailsShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.resendBookingDetailsFn.bind(this, gridObjData)}><span><i className="fa fa-file-text"></i></span>Resend Booking Details</button>
                    </div> : null}

                    {createInvoiceBtnShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.createInvoiceFn.bind(this, gridObjData)}><span><i className="fa fa-file-text"></i></span>Create Invoice</button>
                    </div> : null}

                    {roomEditBtnShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.roomEdit.bind(this, gridObjData)}><span><i className="fa fa-pencil"></i></span>Change Room</button>
                    </div> : null}

                    {staffHistoryButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.hostory.bind(this, gridObjData)}><span><i className="fa fa-history"></i></span>History</button>
                    </div> : null}
                    {resendQuationButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.resendQuation.bind(this, gridObjData)}><span><i className="fa fa-repeat"></i></span>Resend Quotation</button>
                    </div> : null}

                    {/* //========== for quation module ==============// */}
                    {this.props.resendButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.resendBtnFn.bind(this, gridObjData)}><span><i className="fa fa-repeat"></i></span>Resend</button>
                    </div> : null}

                    {this.props.copyButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.copyBtnFn.bind(this, gridObjData)}><span><i className="fa fa-copy"></i></span>Copy</button>
                    </div> : null}

                    {this.props.markAsPaidButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.markAsPaidFn.bind(this, gridObjData)}><span><i className="fa fa-credit-card"></i></span>{this.props.markAsLabel}</button>
                    </div> : null}

                    {this.props.markAsConfirmedButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.markAsConfirmedFn.bind(this, gridObjData)}><span><i className="fa fa-check"></i></span>Mark as Confirmed</button>
                    </div> : null}

                    {this.props.markAsExpiredButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.markAsExpiredFn.bind(this, gridObjData)}><span><i className="fa fa-exclamation-triangle"></i></span>Mark as Expired</button>
                    </div> : null}

                    {this.props.convertToInvoiceButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.convertToInvoiceFn.bind(this, gridObjData)}><span><i className="fa fa-exchange"></i></span>Convert to Invoice</button>
                    </div> : null}
                    {this.props.viewOnlyButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.viewOnlyBtnFn.bind(this, gridObjData)}><span><i className="fa fa-eye"></i></span>View Only</button>
                    </div> : null}
                    {/* //========== end for quation module ==============// */}

                    {subscribeNow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.opensubscribeModal.bind(this, gridObjData)}><span><i className="fa fa-plus"></i></span>Add Subscription</button>
                    </div> : null}

                    {renewsubscribe ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.opensubscribeModal.bind(this, gridObjData)}><span><i className="fa fa-refresh"></i></span>Renew Subscription</button>
                    </div> : null}

                    {subscribeEdit ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.opensubscribeModal.bind(this, gridObjData)}><span><i className="fa fa-pencil"></i></span>Edit Subscription</button>
                    </div> : null}
                    {subscribeExtendNow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.opensubscribeModal.bind(this, gridObjData, 'Extend')}><span><i className="fa fa-eye"></i></span>Extend Subscription</button>
                    </div> : null}
                    {paymentDetailsShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.paymentDetails.bind(this, gridObjData)}><span><i className="fa fa-eye"></i></span>Payment Details</button>
                    </div> : null}
                    {paymentAcceptShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.paymentAccept.bind(this, gridObjData)}><span><i className="fa fa-check"></i></span>Accept</button>
                    </div> : null}
                    {paymentRejectShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.paymentReject.bind(this, gridObjData)}><span><i className="fa fa-times"></i></span>Reject</button>
                    </div> : null}

                    {approveShow ? <div className="actionableRow">

                        <button className="actionableIcon" onClick={this.props.approve.bind(this, gridObjData)}><span><i className="fa fa-check"></i></span>Mark as Confirmed</button>

                    </div> : null}
                    {personDetailsShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.personDetailsFn.bind(this, gridObjData)}><span><i className="fa fa-users"></i></span>Guest Details</button>
                    </div> : null}
                    {auditHistoryShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.auditHistoryFn.bind(this, gridObjData)}><span><i className="fa fa-history"></i></span>Audit History</button>
                    </div> : null}
                    {beneficiarySettlementShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.beneficiarySettlement.bind(this, gridObjData)}><span><i className="fa fa-handshake"></i></span>{beneficiarySettlementLabel}</button>
                    </div> : null}
                    {give_me_authorization_show ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.giveMeAuthorization.bind(this, gridObjData)}><span><i className="fa fa-lock"></i></span>Request for authorization</button>
                    </div> : null}
                    {add_to_active_list_show ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.returnActiveList.bind(this, gridObjData)}><span><i className="fa fa-add"></i></span>Add to active list</button>
                    </div> : null}
                    {remove_property_show ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.removeProperty.bind(this, gridObjData)}><span><i className="fa fa-trash"></i></span>Remove from Active List</button>
                    </div> : null}
                    {completeBookingShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.completeBookingFn.bind(this, gridObjData)}><span><i className="fa-solid fa-square-check"></i></span>{gridObjData?.data?.status == '5' ? "Mark As Completed" : "Checked-In"}</button>
                    </div> : null}

                    {assignRoomNumberShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.assignRoomNumber.bind(this, gridObjData)}><span><i className="fa-solid fa-square-check"></i></span>Assign Room Number</button>
                    </div> : null}

                </div>
            </div>
        );
    }
}
GridActionContent.defaultProps = {
    editButtonShow: true,
    deleteButtonShow: true,
    roleManagePermissionButtonShow: false,
    cancellationBtnShow: false,
    checkinCheckoutBtnShow: false,
    checkinCheckoutLabel: "Checkin",
    roomEditBtnShow: false,
    createInvoiceBtnShow: false,
    makePaymentShow: false,
    quotationDetailsShow: false,
    quotationBookingConversionBtnShow: false,
    resendBookingDetailsShow: false,
    staffHistoryButtonShow: false,
    resendQuationButtonShow: false,
    viewButtonShow: false,
    subscribeNow: false,
    renewsubscribe: false,
    subscribeEdit: false,
    subscribeExtendNow: false,
    makeDefaultButtonShow: false,
    makePaymentDetailsShow: false,
    paymentDetailsShow: false,
    approveShow: false,
    personDetailsShow: false,
    paymentAcceptShow: false,
    paymentRejectShow: false,
    auditHistoryShow: false,
    beneficiarySettlementShow: false,
    addPaymentShow: false,
    beneficiarySettlementLabel: "Beneficiary Settlement",
    give_me_authorization_show: false,
    viewLabel: "Booking Details",
    add_to_active_list_show: false,
    remove_property_show: false,
    completeBookingShow: false,
    assignRoomNumberShow: false,
}
const mapStateToProps = (globalState) => {
    return {

    };
}

export default connect(mapStateToProps, {})
    (withTranslation()(GridActionContent));